import { PbProductType } from '@/enums/PbProductType'
import { PbSubcategory } from '@/enums/PbSubcategory'

export const WestVirginiaCustomItems = {
	[PbProductType.Service]: {
		[PbSubcategory.ServiceBasicServicesOfFDAndStaff]: [],
		[PbSubcategory.ServiceEmbalming]: [],
		[PbSubcategory.ServiceBodyPreparation]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.ServiceFuneralMemorial]: [],
		[PbSubcategory.ServiceVisitationViewing]: [
			{
				prop: 'numberOfDays',
				label: 'Number of Days',
				type: 'number',
				required: false,
			},
			{
				prop: 'amountPerDay',
				label: 'Amount Per Day',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.ServiceOtherFacilities]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.Other]: [],
		[PbSubcategory.Discount]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
	},
	[PbProductType.Transportation]: {
		[PbSubcategory.TransportationTransfer]: [
			{
				prop: 'mileRadiusForStandardService',
				label: 'Mile Radius for Standard Service',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.TransportationAutomotiveOther]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
	},
	[PbProductType.Merchandise]: {
		[PbSubcategory.MerchandiseCasket]: [
			{
				prop: 'productManufacturer',
				label: 'Product Manufacturer',
				type: 'text',
				required: false,
			},
			{
				prop: 'modelNameNumber',
				label: 'Model Name/Number',
				type: 'text',
				required: false,
			},
			{
				prop: 'exteriorDescription',
				label: 'Exterior Description',
				type: 'text',
				required: false,
			},
			{
				prop: 'interiorDescription',
				label: 'Interior Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.MerchandiseOuterBurialContainer]: [
			{
				prop: 'productManufacturer',
				label: 'Product Manufacturer',
				type: 'text',
				required: false,
			},
			{
				prop: 'modelNameNumber',
				label: 'Model Name/Number',
				type: 'text',
				required: false,
			},
			{
				prop: 'exteriorDescription',
				label: 'Exterior Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.MerchandiseUrn]: [
			{
				prop: 'productManufacturer',
				label: 'Product Manufacturer',
				type: 'text',
				required: false,
			},
			{
				prop: 'modelNameNumber',
				label: 'Model Name/Number',
				type: 'text',
				required: false,
			},
			{
				prop: 'exteriorDescription',
				label: 'Exterior Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.Other]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.Discount]: [],
	},

	[PbProductType.CashAdvance]: {
		[PbSubcategory.Other]: [],
		[PbSubcategory.Discount]: [],
	},
}
